import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { message, Spin, Carousel } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import logo from "../../Asserts/Logo/Logo.png";
import "./auth.css";
import image1 from "../../Asserts/Images/login-image.png";
import Instance from "../../AxiosConfig";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleLogin = () => {
    if (!email.match(emailRegex)) {
      message.error("Please enter a valid email address.");
      return;
    }
    loginUser(email, password);
  };

const loginUser = async (email, password) => {
  setLoading(true)
  try {
    const response = await Instance.post(
      "auth/login",
      { email, password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response,"login");
     if (response.status === 200) {
      const { email, id, role, token, userName, success } = response.data;

      const userData = {
        email,
        id,
        role,
        token,
        userName,
        success
      };

      localStorage.setItem("userData", JSON.stringify(userData));

      message.success("Login successful!");
      navigate("/dashboard");
    }
  } catch (error) {
  console.error("Login error:", error);
  if (error.response && error.response.data && error.response.data.message) {

    message.error(error.response.data.message || error.response.data.error || "Invalid" );
  } else {
     
    message.error("Invalid email or password.");
  }
} finally {
    console.log("Login request completed");
    setLoading(false);
  }
};


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-sm-0 col-md-0">
            <div className="login-image">
              <img src={image1} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 col-md-12">
            <div className="login-form">
              <center>
                <img
                  src={logo}
                  alt="Reliance Foundation Hospital"
                  className="logo"
                />
              </center>
              <p className="login--p">Login</p>
              <p>“Get Started with Your Admin Account”</p>
              <form
                className="login-form-inner"
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className="form-group">
                  <label htmlFor="email">Email*</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    className="signin-input"
                  />
                </div>
                <div className="form-group">
                  <div className="d-flex justify-content-between">
                    <label htmlFor="password">Password*</label>
                    <Link to="/forgot-password" className="forgot-password">
                      Forgot Password?
                    </Link>
                  </div>
                  <div className="password-input">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      placeholder="Enter your Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="signin-input"
                    />
                    <button
                      className="password-toggle"
                      type="button"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <FiEye /> : <FiEyeOff />}
                    </button>
                  </div>
                </div>

                <button
                  className={`login-button mt-3 ${
                    email && password ? "active" : "disabled"
                  }`}
                  onClick={handleLogin}
                  type="submit"
                  disabled={!email || !password}
                >
                  {loading ? (
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{ fontSize: 24, color: "#fff" }}
                          spin
                        />
                      }
                    />
                  ) : (
                    "Log In"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
